(function(){
  /* Halden & Hale cart: complimentary cedar shoe trees + Black Friday tier progress */
  var GIFT_ID = 67848035696829;
  var lock = false;
  var lastSig = '';
  var JA = (document.documentElement.lang||'').toLowerCase().indexOf('ja')===0;

  function promo(){return window.HHP&&HHP.current();}
  function pairs(cart){var q=0;cart.items.forEach(function(i){if(i.variant_id!==GIFT_ID)q+=i.quantity;});return q;}
  function giftLine(cart){return cart.items.filter(function(i){return i.variant_id===GIFT_ID;})[0];}
  function money(c){
    try{return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'GBP'}).format(c/100);}
    catch(e){return (c/100).toFixed(2);}
  }

  function paint(cart){
    var qty=pairs(cart);
    var box=document.getElementById('ssco');
    var p=promo();
    if(box){
      if(!p){box.style.display='none';return;}
      box.style.display='';
      var t=p.t;
      var fill=document.getElementById('sscoFill');
      var msg=document.getElementById('sscoMsg');
      var pct=qty>=4?100:qty>=3?66:qty>=2?33:(qty>=1?16:0);
      if(fill)fill.style.width=pct+'%';
      box.querySelectorAll('.ssco-step').forEach(function(st){
        var s=parseInt(st.getAttribute('data-step'),10);
        st.classList.toggle('on',qty>=s);
        var l=st.querySelector('.ssco-lbl');
        if(l)l.innerHTML=JA?(t[s-2]+'%OFF<br>'+s+'足'+(s===4?'以上':'')):(t[s-2]+'%<br>'+s+(s===4?'+':'')+' pairs');
      });
      if(msg){
        if(JA){
          if(qty>=4)msg.innerHTML='最大割引が適用されました：<b>'+t[2]+'%OFF</b>';
          else if(qty===3)msg.innerHTML='<b>'+t[1]+'%OFF</b>適用中。あと1足で<b>'+t[2]+'%OFF</b>';
          else if(qty===2)msg.innerHTML='<b>'+t[0]+'%OFF</b>適用中。あと1足で<b>'+t[1]+'%OFF</b>';
          else if(qty===1)msg.innerHTML='あと1足で<b>'+t[0]+'%OFF</b>';
          else msg.innerHTML='2足選ぶと<b>'+t[0]+'%OFF</b>';
        } else {
          if(qty>=4)msg.innerHTML='Best saving unlocked: <b>'+t[2]+'% off</b> your pairs';
          else if(qty===3)msg.innerHTML='<b>'+t[1]+'% off</b> unlocked. Add 1 more pair for <b>'+t[2]+'% off</b>';
          else if(qty===2)msg.innerHTML='<b>'+t[0]+'% off</b> unlocked. Add 1 more pair for <b>'+t[1]+'% off</b>';
          else if(qty===1)msg.innerHTML='Add 1 more pair to save <b>'+t[0]+'%</b>';
          else msg.innerHTML='Choose 2 pairs to save <b>'+t[0]+'%</b>';
        }
      }
      var ph=document.getElementById('sscoPhase');if(ph)ph.textContent=JA?'ブラックフライデー':p.name;
    }
    var sav=document.getElementById('sscoSav');
    if(sav){
      var d=cart.total_discount||0;
      var v=sav.querySelector('.ssco-sav-val');
      if(d>0&&v){v.textContent='-'+money(d);sav.style.display='flex';}else{sav.style.display='none';}
    }
  }

  function reloadDrawer(){
    fetch(window.location.pathname+'?sections=cart-drawer-section',{cache:'no-store'})
      .then(function(r){return r.json();})
      .then(function(data){
        var html=data['cart-drawer-section'];
        if(!html){ read(); return; }
        var doc=new DOMParser().parseFromString(html,'text/html');
        var novo=doc.querySelector('cart-drawer-component');
        var atual=document.querySelector('cart-drawer-component');
        if(novo&&atual&&novo.innerHTML!==atual.innerHTML){
          atual.style.transition='none';
          atual.innerHTML=novo.innerHTML;
        }
        setTimeout(read,120);
      })
      .catch(function(){ setTimeout(read,250); });
  }

  function syncGift(cart){
    if(lock) return;
    var qty=pairs(cart);
    var g=giftLine(cart);
    var active=!!promo();
    var url,body;

    if(active && qty>=1 && !g){ url='/cart/add.js'; body={id:GIFT_ID,quantity:1}; }
    else if((qty<1 || !active) && g){ url='/cart/change.js'; body={id:String(GIFT_ID),quantity:0}; }
    else if(g && g.quantity!==1){ url='/cart/change.js'; body={id:String(GIFT_ID),quantity:1}; }
    else { return; }

    lock=true;
    fetch(url,{method:'POST',hhInternal:true,headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
      .then(function(r){return r.json();})
      .then(function(){ setTimeout(function(){ lock=false; reloadDrawer(); },180); })
      .catch(function(){ lock=false; });
  }

  function read(){
    fetch('/cart.js',{cache:'no-store'})
      .then(function(r){return r.json();})
      .then(function(cart){
        var sig=cart.item_count+'|'+cart.items.map(function(i){return i.variant_id+':'+i.quantity;}).join(',');
        paint(cart);
        if(sig!==lastSig){ lastSig=sig; syncGift(cart); }
      })
      .catch(function(){});
  }

  /* Real countdown to the end of the current promotion phase (no fake timers) */
  function timer(){
    var el=document.getElementById('sscoTimer'); if(!el||!window.HHP) return;
    var p=promo(); if(!p) return;
    var l=HHP.left(p.end);
    el.textContent=JA?((l.d>0?l.d+'日 ':'')+HHP.pad(l.h)+'時間'+HHP.pad(l.m)+'分'):((l.d>0?l.d+'d ':'')+HHP.pad(l.h)+'h '+HHP.pad(l.m)+'m');
  }

  function loop(){ timer(); read(); }

  ['cart:change','cart:updated','cart:update','cart:refresh','variant:add','cart:build'].forEach(function(e){
    document.addEventListener(e,function(){ setTimeout(read,400); });
    document.documentElement.addEventListener(e,function(){ setTimeout(read,400); });
  });

  document.addEventListener('click',function(e){
    if(e.target.closest&&e.target.closest('cart-drawer-component, product-form-component, form[action*="/cart"], [name="add"], [data-cart-drawer], .header-actions__cart-icon')){
      setTimeout(read,600);
      setTimeout(read,1200);
    }
  },true);

  /* Re-read whenever anything on the page changes the cart (theme, apps, Shop Pay) */
  if(window.fetch&&!window.__hhFetchWrapped){
    window.__hhFetchWrapped=true;
    var _f=window.fetch;
    window.fetch=function(input,init){
      var u=typeof input==='string'?input:(input&&input.url)||'';
      var p=_f.apply(this,arguments);
      if(/\/cart\/(add|change|update|clear)/.test(u)&&!(init&&init.hhInternal)){ p.then(function(){ setTimeout(read,350); },function(){}); }
      return p;
    };
  }

  /* Read the cart once after the page is ready, then only when the cart changes (no polling) */
  function start(){ (window.requestIdleCallback||function(f){setTimeout(f,200);})(loop); }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  window.addEventListener('pageshow',function(e){ if(e.persisted) read(); });
  document.addEventListener('visibilitychange',function(){ if(document.visibilityState==='visible') read(); });
})();